import I18n from 'I18n';
import { useCallback } from 'react';
import styled from 'styled-components';
import { TableCell } from 'foundations-components/transitional/components/Table';
import SummaryRecipientContactCell from './SummaryRecipientContactCell';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledRow = styled.tr.withConfig({
  displayName: "SummaryRecipientsTableRow__StyledRow"
})(["cursor:pointer;"]);
const SummaryRecipientsTableRow = ({
  deckVisitor,
  onViewDetails
}) => {
  const lastViewedValue = deckVisitor.get('lastViewed');
  const lastViewed = I18n.moment.userTz(lastViewedValue).fromNow();
  const views = deckVisitor.get('views');
  const contact = deckVisitor === null || deckVisitor === void 0 ? void 0 : deckVisitor.get('contact');
  const handleClick = useCallback(event => {
    onViewDetails(event);
  }, [onViewDetails]);
  return /*#__PURE__*/_jsxs(StyledRow, {
    "data-test-id": "summary-recipients-table-row",
    onClick: handleClick,
    children: [/*#__PURE__*/_jsx(SummaryRecipientContactCell, {
      contact: contact,
      onViewDetails: onViewDetails
    }), /*#__PURE__*/_jsx(TableCell, {
      textAlign: "right",
      children: views.toString()
    }), /*#__PURE__*/_jsx(TableCell, {
      textAlign: "right",
      children: lastViewed
    })]
  });
};
export default SummaryRecipientsTableRow;